import { render, staticRenderFns } from "./demandPublishSetting.vue?vue&type=template&id=26364629&scoped=true&"
import script from "./demandPublishSetting.vue?vue&type=script&lang=js&"
export * from "./demandPublishSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26364629",
  null
  
)

export default component.exports